/**
 * 产品列表页面相关的模拟数据
 */

// 支付产品数据
export const paymentProducts = [
  { id: 1, productName: '产品A', productCode: '8888', rate: 10.00 },
  { id: 2, productName: '产品B', productCode: 'WX001', rate: 3.50 },
  { id: 3, productName: '产品C', productCode: 'ZFB001', rate: 3.00 },
  { id: 4, productName: '产品D', productCode: 'YL001', rate: 2.80 },
  { id: 5, productName: '产品E', productCode: 'YSF001', rate: 2.50 },
  { id: 6, productName: '产品F', productCode: 'ICC001', rate: 4.50 },
  { id: 7, productName: '产品G', productCode: 'QP001', rate: 2.60 },
  { id: 8, productName: '产品H', productCode: 'AGG001', rate: 3.80 },
  { id: 9, productName: '产品I', productCode: 'SCAN001', rate: 2.20 }
];

// 供应商通道数据
export const supplierChannels = [
  { id: 101, channelName: '通道A', channelCode: 'A', rate: 6.00 },
  { id: 102, channelName: '通道B', channelCode: 'B', rate: 6.00 },
  { id: 103, channelName: '通道C', channelCode: 'C', rate: 5.80 },
  { id: 104, channelName: '通道D', channelCode: 'D', rate: 5.90 },
  { id: 105, channelName: '通道E', channelCode: 'E', rate: 6.20 },
  { id: 106, channelName: '通道F', channelCode: 'F', rate: 6.30 }
]; 